__turbopack_context__.v({
  "clamp": "Heading-module__FOAy3G__clamp" + " " + __turbopack_context__.i(7213)["lineClamp"],
  "h1": "Heading-module__FOAy3G__h1",
  "h2": "Heading-module__FOAy3G__h2",
  "h3": "Heading-module__FOAy3G__h3",
  "h4": "Heading-module__FOAy3G__h4",
  "h5": "Heading-module__FOAy3G__h5",
  "h6": "Heading-module__FOAy3G__h6",
  "root": "Heading-module__FOAy3G__root",
  "shadow": "Heading-module__FOAy3G__shadow",
});
